import React from "react";
import { useSearchParams } from "react-router-dom";
import RentCardContainer from '../../Components/CardContainerForRent/CardContainerForRent';
import FilterView from "../../Components/FilterView/FilterView";
import {
  getFiltersFromSearchParams,
  filtersToSearchParams,
} from "../../utils/propertyCatalogFilters";
import styles from "./Rent.module.css"

const Rent = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filtersFromURL = getFiltersFromSearchParams(searchParams);
  const page = parseInt(searchParams.get("page"), 10) || 1;

  // Al aplicar filtros se reinicia la paginación a la página 1.
  const handleFilterChange = (filters) => {
    setSearchParams(filtersToSearchParams(filters, { page: 1 }));
  };

  return (
    <div className={styles.container}>
       <FilterView onFilterChange={handleFilterChange} initialFilters={filtersFromURL} />
      <RentCardContainer filters={{ ...filtersFromURL, page }} />
    </div>
  );
};

export default Rent;
